import { useEffect, useState } from 'react';
/**
 * Debounces a value by the specified delay.
 * Returns the debounced value that only updates after the delay.
 */
export function useDebounce(value, delayMs = 300) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(timer);
    }, [value, delayMs]);
    return debounced;
}
//# sourceMappingURL=useDebounce.js.map